import React from 'react';
import { RootContext, UserApiV1InstitutionPath, UserApiV1InstitutionMenusPath } from '../../../index';

export default class LandingPage extends React.Component {
  static contextType = RootContext;

  componentDidMount () {
    const id = location.pathname.split('/').filter(s => s !== '').slice(-1)[0];
    this.context.showLoading();
    Promise.all([
      this.context.fetch(UserApiV1InstitutionPath(id)),
      this.context.fetch(UserApiV1InstitutionMenusPath(id)),
    ]).then(body => {
      this.setState({ institution: body[0].result, menus: body[1].results });
    }).finally(() => {
      this.context.hideLoading();
    });
  }

  onClickMenu (url) {
    location.href = url;
  }

  renderTreatmentCategoryTag (menu) {
    if (menu.treatment_category === 'regional_medical_cooperation') return null;

    return (
      <div className="mb-sm">
        <span className={menu.treatment_category === 'insurance' ? 'c-mn-tag c-mn-tag--green' : 'c-mn-tag c-mn-tag--blue'}>{this.context.t(`menus.treatment_categories.${menu.treatment_category}`)}</span>
      </div>
    );
  }

  renderMenuFees (menu) {
    if (menu.treatment_category === 'regional_medical_cooperation') return null;

    return (
      <>
        <p className={menu.menu_fees.length > 0 ? 'fz-ll lh-sm fw-br' : 'd-n'}>{this.context.t('LandingPage.price_tax_excluded')}</p>
        {menu.menu_fees.map(fee => {
          return (
            <div key={fee.code} className="p-lp--fee">
              <div>{fee.name}</div>
              <div>{fee.amount}</div>
            </div>
          );
        })}
      </>
    );
  }

  render () {
    return (
      <div className="p-container p-lp">
        <div className={ this.state?.institution && this.state?.menus ? 'l-conatiner' : 'd-n' }>
          <h4 className="w90p c-mn-title-2 ta-c">{this.state?.institution?.name}</h4>
          {this.state?.institution?.page_sections?.map(page => {
            return (
              <div key={page.code} className="p-container--content">
                <h5 className="fz-xl lh-md fw-br mb-sm">{page.title}</h5>
                {this.context.formatSimple(page.description)}
              </div>
            );
          })}
          <div className="p-container--hr"></div>
          <h4 className="sub w90p c-mn-title-2 ta-c">{this.context.t('LandingPage.treatment_menu')}</h4>
          {this.state?.menus?.map(menu => {
            return (
              <div key={menu.id} className="p-container--card p-lp--card">
                {this.renderTreatmentCategoryTag(menu)}
                <h5 className="fz-xl lh-sm fw-br">{menu.title}</h5>
                {this.context.formatSimple(menu.description)}
                {this.renderMenuFees(menu)}
                <button className="c-mn-btn--first" onClick={ () => { this.onClickMenu(menu.url_location.show); } } disabled={!this.state?.institution?.is_service}><span>{ this.state?.institution?.is_service ? this.context.t('LandingPage.apply') : this.context.t('LandingPage.closed') }</span></button>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
